

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getQueryParams } from '../../../../shared/src/utilities/helpers'

@Component({})
export default class YouTubePlayer extends Vue {
  @Prop({ required: true }) youTubeIframeApiReady!: boolean
  @Prop({ required: true }) url!: string
  @Prop({ default: '400' }) width!: string
  @Prop({ default: '300' }) height!: string
  @Prop({ default: false }) autoplay!: boolean
  @Prop({ required: false }) playerStateOverride!: boolean // used to trigger plays after iframe load
  @Prop({ required: false }) forceFullScreen!: boolean

  siteOrigin = window.location.origin

  player?: YT.Player | null = null
  playingStarted = false
  iframeId = 'youtube-player' // If you change this, adjust CSS accordingly

  mounted () {
    this.initializePlayer(this.youTubeIframeApiReady) // Player initialization should happen no earlier than component mounting; YouTube's iframe API requires the iframe to already exist in the DOM. 
  }

  get fullIframeSrc () {
    const baseURL = `https://www.youtube.com/embed/${this.videoId}`
    let fullUrl = `${baseURL}?enablejsapi=1&origin=${this.siteOrigin}`
    if (this.autoplay) fullUrl += '&autoplay=1'
    return fullUrl
  }

  get videoId () {
    if (this.url.includes('youtube.com')) {
      const youtubeQS = '?' + this.url.split('?')[1]
      const videoId = getQueryParams(youtubeQS).v
      // https://youtu.be/AMUs9KPMqj8
      return videoId
    } else if (this.url.includes('youtu.be')) {
      const splitByPath = this.url.split('/')
      const videoId = splitByPath[splitByPath.length - 1]
      return videoId
    }
  }

  @Watch('fullIframeSrc', { immediate: true })
  validateIframeSrc () {
    const doesntContainEmbed = !this.fullIframeSrc.includes('embed')
    const isntYoutube = !this.fullIframeSrc.match(/^(youtube.com|youtu.be)$/)
    const invalid = doesntContainEmbed || isntYoutube
    if (invalid) {
      this.$emit('invalid-youtube-url')
    }
  }

  @Watch('youTubeIframeApiReady')
  initializePlayer (youTubeIframeApiReady: boolean) {
    if (youTubeIframeApiReady) {
      this.player = new YT.Player(this.iframeId, {
        events: {
          'onReady': () => console.log('player ready'),
          'onStateChange': this.onPlayerStateChange,
        }
      })
    }
  }

  @Watch('playerStateOverride')
  adjustPlayerState (playerStateOverride: boolean) {
    if (playerStateOverride === true && this.player) {
      this.player.playVideo()
    }
  }

  onPlayerStateChange (event: YT.OnStateChangeEvent) {
    const playerState = event.data
    if (playerState === YT.PlayerState.UNSTARTED || playerState === YT.PlayerState.PLAYING) {
      if (!this.playingStarted) {
        this.$emit('play-started')
        this.playingStarted = true
      }
      if (this.forceFullScreen) {
        this.expandToFullScreen()
      }
    }

    if (playerState === YT.PlayerState.ENDED || playerState === YT.PlayerState.PAUSED) {
      if (document.fullscreenElement && document.fullscreenElement.id === this.iframeId) { 
        document.exitFullscreen()
      }
      this.$emit('play-stopped')
    }
  }

  expandToFullScreen () {
    const iframe = document.getElementById(this.iframeId)! as any
    iframe.requestFullscreen()
  }

  exitFullScreen () {
    document.exitFullscreen()
  }
}
